module.exports = __webpack_public_path__ + "static/media/d.e81b2b1c.png";